module.exports = __webpack_public_path__ + "website/img/imgth_l.82fdbe14.png";